<div class="row ng-scope">
  <div class="col-12">

    <div class="row form-group">
      <label class="control-label col-2">{{'Mã/Quyển' | translate}}</label>
      <div class="col-2">
        <input type="text" tabIndex="1" class="form-control" placeholder="Quyển" [(ngModel)]="doituongSelect.QuyenSo">
      </div>
      <div class="col-2">
        <input class="form-control"
               maxlength="20"
               tabindex="2"
               currencyMask
               [(ngModel)]="doituongSelect.SoPhieu"
               name="value"
               [placeholder]="'Số phiếu'"
               [options]="ngxCurrencyOption2s" autocomplete="off" />
      </div>
      <label class="control-label col-2">{{'Ngày lập/Ngày CT' | translate}}</label>
      <div class="col-2">
        <kendo-dateinput tabindex="3" style="width:100%;" [format]="'dd/MM/yyyy'" [(value)]="doituongSelect.Ngay"></kendo-dateinput>
      </div>
      <div class="col-2">
        <kendo-dateinput tabindex="4" style="width:100%;" [format]="'dd/MM/yyyy'" [(value)]="doituongSelect.NgayChungTu"></kendo-dateinput>
      </div>
    </div>

    <div class="row form-group">
      <label class="control-label col-2">{{ngonngu(tennguoinop)}}<span class="cred">(*)</span></label>
      <div class="col-6" style="display: flex;">
        <div class="input-group" style="width: 300px;">
          <input type="text" class="form-control" readonly [(ngModel)]="doituongSelect.MaNV" placeholder="Mã">
          <div class="input-group-append">
            <button class="btn btn-outline-secondary" type="button" (click)="openNguoiModal()" style="height:25px;">
              <i class="fa fa-ellipsis-h"></i>
            </button>
            <button class="btn btn-outline-secondary" type="button" (click)="xoaDoiTuong()" style="height:25px;" *ngIf="doituongSelect.KhoaHocTen">
              <i class="fa fa-times"></i>
            </button>
          </div>
        </div>
        <input type="text" #mafocus tabIndex="5" class="form-control" placeholder="" [(ngModel)]="doituongSelect.HoVaTen">
      </div>
      <label class="control-label col-2 ng-binding">Số tiền<span class="cred">(*)</span></label>
      <div class="col-2">
        <input class="form-control"
               maxlength="20"
               tabindex="6"
               currencyMask
               [(ngModel)]="doituongSelect.SoTien"
               name="value"
               [placeholder]="'Số tiền'"
               [options]="ngxCurrencyOptions" autocomplete="off" />
      </div>
    </div>

    <div class="row form-group">
      <label class="control-label col-2 ng-binding">Địa chỉ</label>
      <div class="col-10">
        <input type="text" tabIndex="7" class="form-control" placeholder="" [(ngModel)]="doituongSelect.DiaChi">
      </div>

    </div>

    <div class="row form-group">
      <label class="control-label col-2 ng-binding">Lý do</label>
      <div class="col-10">
        <textarea type="text" tabIndex="9" rows="3" class="form-control" placeholder="" [(ngModel)]="doituongSelect.GhiChu"></textarea>
      </div>
    </div>

    <div class="row form-group">
      <label class="control-label col-2">{{'Phương thức' | translate}}<span class="cred">(*)</span></label>
      <div class="col-4">
        <ng-select #slPhuongThuc
                   class="twcollong"
                   [tabIndex]="10"
                   [openOnEnter]="false"
                   [items]="inputphuongthucs"
                   bindValue="Id"
                   bindLabel="Ten"
                   notFoundText="Không có dữ liệu"
                   [searchFn]="comboSearchFn2"
                   [(ngModel)]="doituongSelect.PhuongThuc">
          <ng-template ng-footer-tmp>
            <a (click)="AddKhoHang()"><em class="mr-2 far fa-plus-square" style="color:red;font-weight:bold"></em>Thêm mới</a>
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            <div class="rTableRow">
              <div class="rTableCell_1">{{item.Ten}}</div>
            </div>
          </ng-template>
        </ng-select>
      </div>
      <label class="control-label col-2">{{'Khoản mục' | translate}}</label>
      <div class="col-4">
        <ng-select #slKho
                   class="twcollong"
                   [tabIndex]="2"
                   [openOnEnter]="false"
                   [items]="dsloaiphieus"
                   bindValue="Id"
                   bindLabel="Ten"
                   notFoundText="Không có dữ liệu"
                   [searchFn]="comboSearchFn2"
                   [(ngModel)]="doituongSelect.LoaiPhieuId">
          <ng-template ng-footer-tmp>
            <a (click)="adddata_LoaiPhieu()"><em class="mr-2 far fa-plus-square" style="color:red;font-weight:bold"></em>Thêm mới</a>
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            <div class="rTableRow">
              <div class="rTableCell_1">{{item.Ten}}</div>
            </div>
          </ng-template>
        </ng-select>
      </div>
    </div>
    <div class="row form-group">
      <label class="control-label col-2">{{'Khóa học' | translate}}</label>
      <div class="col-4">
        <div class="input-group">
          <input type="text" class="form-control" readonly [(ngModel)]="doituongSelect.KhoaHocTen" placeholder="Chọn khóa học">
          <div class="input-group-append">
            <button class="btn btn-outline-secondary" type="button" (click)="openKhoaHocModal()" style="height:25px;">
              <i class="fa fa-ellipsis-h"></i>
            </button>
            <button class="btn btn-outline-secondary" type="button" (click)="xoaKhoaHoc()" style="height:25px;" *ngIf="doituongSelect.KhoaHocTen">
              <i class="fa fa-times"></i>
            </button>
          </div>
        </div>
      </div>
      <label class="control-label col-2">{{'Hình thức' | translate}}</label>
      <div class="col-4">
        <ng-select class="twcollong"
                   [tabIndex]="11"
                   [openOnEnter]="false"
                   [items]="hinhThucThanhToans"
                   bindValue="Id"
                   bindLabel="Ten"
                   notFoundText="Không có dữ liệu"
                   [(ngModel)]="doituongSelect.HinhThuc">
          <ng-template ng-option-tmp let-item="item">
            <div class="rTableRow">
              <div class="rTableCell_1">{{item.Ten}}</div>
            </div>
          </ng-template>
        </ng-select>
      </div>
    </div>
    <div class="row form-group">
      <label class="control-label col-2">Số căn cước<span class="cred"></span></label>
      <div class="col-4">
        <input type="text" #mafocus tabIndex="5" class="form-control" placeholder="" [(ngModel)]="doituongSelect.SoCanCuoc">
      </div>
      <label class="control-label col-2">{{'Đơn vị' | translate}}<span class="cred">(*)</span></label>
      <div class="col-4">
        <ng-select #slChiNhanh
                   class="twcollong"
                   [tabIndex]="1"
                   [openOnEnter]="false"
                   [items]="dschinhanhs"
                   bindValue="Id"
                   bindLabel="Ten"
                   notFoundText="Không có dữ liệu"
                   [searchFn]="comboSearchFn2"
                   (change)="changeChiNhanh($event)"
                   [(ngModel)]="doituongSelect.DonViId">
          <ng-template ng-option-tmp let-item="item">
            <div class="rTableRow">
              <div class="rTableCell_1">{{item.Ten}}</div>
            </div>
          </ng-template>
        </ng-select>
      </div>

    </div>

    <!--<div class="row form-group">
      <label class="control-label col-2 ng-binding">Ngày tạo</label>
      <div class="col-4" style="font-weight:bold">
        {{doituongSelect.Created | date:'dd/MM/yyyy HH:mm:ss'}}
      </div>
      <label class="control-label col-2 ng-binding">Người Tạo</label>
      <div class="col-4">
        <input type="text" tabIndex="14" class="form-control" placeholder="" disabled="disabled" [(ngModel)]="doituongSelect.CreatedBy">
      </div>
    </div>


    <div class="row form-group">
      <label class="control-label col-2 ng-binding">Ngày sửa</label>
      <div class="col-4" style="font-weight:bold">
        {{doituongSelect.Modified | date:'dd/MM/yyyy HH:mm:ss'}}
      </div>
      <label class="control-label col-2 ng-binding">Người sửa</label>
      <div class="col-4">
        <input type="text" tabIndex="14" class="form-control" placeholder="" disabled="disabled" [(ngModel)]="doituongSelect.ModifiedBy">
      </div>
    </div>-->



  </div>

</div>
<!-- Add this section after the existing form content, just before the modal-footer div -->
<div class="row form-group" *ngIf="hasPhanBo">
  <div class="col-12">
    <div class="d-flex justify-content-between align-items-center mb-2">
      <h4 class="mb-0">Chi phí phân bổ</h4>
      <button type="button" class="btn btn-danger btn-sm" (click)="xoaChiPhiPhanBo()">
        <i class="far fa-trash-alt"></i> Xóa
      </button>
    </div>

    <table class="table table-bordered table-hover" style="background:#fff;">
      <thead>
        <tr class="bg-light">
          <th style="width: 120px">Ngày</th>
          <th style="width: 250px">Số tiền</th>
          <th>Ghi chú</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="danhSachPhanBo.length === 0">
          <td colspan="3" class="text-center">Không có dữ liệu phân bổ</td>
        </tr>
        <tr *ngFor="let item of danhSachPhanBo">
          <td>{{ item.Ngay | date: 'dd/MM/yyyy' }}</td>
          <td class="text-right">{{ item.SoTien | number }} đ</td>
          <td>{{ item.GhiChu }}</td>
        </tr>
      </tbody>
      <tfoot *ngIf="danhSachPhanBo.length > 0">
        <tr class="font-weight-bold">
          <td class="text-right">Tổng:</td>
          <td class="text-right">{{ getTongTienPhanBo() | number }} đ</td>
          <td></td>
        </tr>
      </tfoot>
    </table>
  </div>
</div>

<div class="modal-footer" style="display: flex;justify-content: space-between;">
  <div style="display:flex;">
    <!--<div class="checkbox c-checkbox">
      <label>
        <input tabIndex="20" type="checkbox" [(ngModel)]="doituongSelect.TrangThai" />
        <span class="fa fa-check"></span> {{'Hoạt động' | translate}}
      </label>
    </div>-->
  </div>

  <div class="">
    <button style="float:left !important" class="mb-1 mr-1 btn btn-secondary" (click)="closeModal()" title="">{{'Hủy bỏ' | translate}}</button>
    <button style="float:left !important" type="submit" (click)="saveproduct()" title="" class="mb-1 mr-1 btn btn-primary">{{'Lưu lại' | translate}}</button>
  </div>

</div>


<!--<div id='target' class="control-section">
  <ejs-dialog #dialogObj id='dialog' [visible]='visible' [header]='dialogHeader' [animationSettings]='animationSettings' [showCloseIcon]='showCloseIcon' (open)="dialogOpen()" (close)="dialogClose()"
              [target]='target' [width]='dialogWidth'>
    <ejs-filemanager #filemanagerObj id='filemanager' (beforeSend)="OnbeforeSend($event)"
                     [ajaxSettings]='ajaxSettings' [toolbarSettings]='toolbarSettings'
                     [contextMenuSettings]='contextMenuSettings'
                     [allowMultiSelection]='false' (fileOpen)="onFileOpen($event)">
    </ejs-filemanager>
  </ejs-dialog>
</div>-->
<bs-modal #mdKhoHang class="modal fade show in" [cssClass]="'modal6'" [backdrop]="'static'" [keyboard]="true">
  <div class="modal-header">
    <h4 class="modal-title">Thêm mới kho hàng</h4>
    <button type="button" aria-label="Dismiss" class="close" (click)="mdKhoHang.close()">
      <span aria-hidden="true">×</span>
    </button><!---->
  </div>
  <bs-modal-body>
    <app-danhmuc-khohangedit #dtekhohangedit (save)="saveModal_Kho($event)"></app-danhmuc-khohangedit>
  </bs-modal-body>
</bs-modal>

<bs-modal #mdNhaCungCap class="modal fade show in" [cssClass]="'modal6'" [backdrop]="'static'" [keyboard]="true">
  <div class="modal-header">
    <h4 class="modal-title">Thêm mới nhà cung cấp</h4>
    <button type="button" aria-label="Dismiss" class="close" (click)="mdNhaCungCap.close()">
      <span aria-hidden="true">×</span>
    </button><!---->
  </div>
  <bs-modal-body>
    <app-danhmuc-nhacungcapedit #dtenhacungcapedit (save)="saveModal_NhaCungCap($event)"></app-danhmuc-nhacungcapedit>
  </bs-modal-body>
</bs-modal>


<bs-modal #mdSanPham class="modal fade show in" [cssClass]="'modal6'" [backdrop]="'static'" [keyboard]="true">
  <div class="modal-header">
    <h4 class="modal-title">Thêm mới sản phẩm</h4>
    <button type="button" aria-label="Dismiss" class="close" (click)="mdSanPham.close()">
      <span aria-hidden="true">×</span>
    </button><!---->
  </div>
  <bs-modal-body>
    <app-danhmuc-sanphamedit #dtesanphamedit (save)="saveModal_SanPham($event)"></app-danhmuc-sanphamedit>
  </bs-modal-body>
</bs-modal>

<!--các hạng mục dùng-->

<bs-modal #myModal class="modal fade show in" [cssClass]="'modal6'" [backdrop]="'static'" [keyboard]="true">
  <div class="modal-header">
    <h4 class="modal-title">Thêm khoản mục</h4>
    <button type="button" aria-label="Dismiss" class="close" (click)="myModal.close()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <bs-modal-body>
    <app-dieuhanh-loaiphieuedit #dteloaiphieuedit (save)="saveModal_LoaiPhieu($event)"></app-dieuhanh-loaiphieuedit>
  </bs-modal-body>
</bs-modal>

<!--ket thuc các hạng mục dùng-->
<!-- Modal popup for KhoaHoc selection -->
<bs-modal #mdKhoaHoc class="modal fade show in" [cssClass]="'modal6'" [backdrop]="'static'" [keyboard]="true">
  <div class="modal-header">
    <h4 class="modal-title">Chọn khóa học</h4>
    <button type="button" aria-label="Dismiss" class="close" (click)="mdKhoaHoc.close()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <bs-modal-body>
    <div class="row mb-3">
      <div class="col">
        <div class="input-group">
          <input type="text" class="form-control" placeholder="Tìm kiếm khóa học..." [(ngModel)]="khoaHocSearchTerm" (keyup)="searchKhoaHoc()">
          <div class="input-group-append">
            <button class="btn btn-outline-primary" type="button" (click)="searchKhoaHoc()" style="height: 25px;">
              <i class="fa fa-search"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div style="height:300px; overflow:auto;">
      <table class="table table-bordered table-hover">
        <thead>
          <tr class="bg-light">
            <th style="width: 100px">Ngày</th>
            <th>Tên khóa học</th>
            <th>học sinh</th>
            <th style="width: 150px">Số tiền</th>
            <th style="width: 50px"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="danhSachKhoaHoc.length === 0">
            <td colspan="5" class="text-center">Không có dữ liệu khóa học</td>
          </tr>
          <tr *ngFor="let item of danhSachKhoaHoc">
            <td>{{ item.Ngay | date: 'dd/MM/yyyy' }}</td>
            <td>{{ item.TenKhoaHoc }}</td>
            <td>{{ item.HoVaTen }}</td>
            <td class="text-right">{{ item.ThucThu | number }} đ</td>
            <td class="text-center">
              <button class="btn btn-sm btn-primary" (click)="chonKhoaHoc(item)">
                <i class="fa fa-check"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

  </bs-modal-body>
</bs-modal>

<!-- Modal popup for Nguoi selection -->
<bs-modal #mdNguoi class="modal fade show in" [cssClass]="'modal-lg'" [backdrop]="'static'" [keyboard]="true">
  <div class="modal-header">
    <h4 class="modal-title">Chọn học sinh</h4>
    <button type="button" aria-label="Dismiss" class="close" (click)="mdNguoi.close()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <bs-modal-body>
    <!-- Search bar -->
    <div class="row mb-3">
      <div class="col">
        <div class="input-group">
          <input type="text"
                 class="form-control"
                 placeholder="Tìm kiếm học sinh..."
                 [(ngModel)]="nguoiSearchTerm"
                 (keyup.enter)="searchNguoi()">
          <div class="input-group-append">
            <button class="btn btn-outline-primary"
                    type="button"
                    (click)="searchNguoi()"
                    style="height: 25px;">
              <i class="fa fa-search"></i>
            </button>
            <button class="btn btn-outline-secondary"
                    type="button"
                    (click)="resetFilterNguoi()"
                    style="height: 25px;"
                    title="Làm mới">
              <i class="fa fa-sync"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Table -->
    <div style="height:400px; overflow:auto;">
      <table class="table table-bordered table-hover table-sm">
        <thead class="thead-light" style="position: sticky; top: 0; z-index: 10; background: white;">
          <tr>
            <th style="width: 120px">Mã HV</th>
            <th style="width: 200px">Họ và tên</th>
            <th style="width: 180px">Tên lớp</th>
            <th style="width: 130px">Điện thoại</th>
            <th style="width: 80px; text-align: center;">Chọn</th>
          </tr>
          <!-- Filter row -->
          <!--<tr style="background: #f8f9fa;">
            <th>
              <input type="text"
                     class="form-control form-control-sm"
                     placeholder="Lọc..."
                     [(ngModel)]="filterNguoi.MaNV"
                     (keyup.enter)="filterNguoiByColumn()">
            </th>
            <th>
              <input type="text"
                     class="form-control form-control-sm"
                     placeholder="Lọc..."
                     [(ngModel)]="filterNguoi.HoVaTen"
                     (keyup.enter)="filterNguoiByColumn()">
            </th>
            <th>
              <input type="text"
                     class="form-control form-control-sm"
                     placeholder="Lọc..."
                     [(ngModel)]="filterNguoi.TenLop"
                     (keyup.enter)="filterNguoiByColumn()">
            </th>
            <th>
              <input type="text"
                     class="form-control form-control-sm"
                     placeholder="Lọc..."
                     [(ngModel)]="filterNguoi.DienThoaiDiDong"
                     (keyup.enter)="filterNguoiByColumn()">
            </th>
            <th></th>
          </tr>-->
        </thead>
        <tbody>
          <tr *ngIf="danhSachNguoi.length === 0">
            <td colspan="5" class="text-center">Không có dữ liệu học sinh</td>
          </tr>
          <tr *ngFor="let item of danhSachNguoi" style="cursor: pointer;" (dblclick)="chonNguoi(item)">
            <td>{{ item.maNV }}</td>
            <td>{{ item.hoVaTen }}</td>
            <td>{{ item.tenLop }}</td>
            <td>{{ item.dienThoaiDiDong }}</td>
            <td class="text-center">
              <button class="btn btn-sm btn-primary"
                      (click)="chonNguoi(item)"
                      title="Chọn học sinh này">
                <i class="fa fa-check"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="mt-2">
      <small class="text-muted">
        <i class="fa fa-info-circle"></i>
        Tìm thấy <strong>{{ danhSachNguoi.length }}</strong> học sinh.
        Click đúp vào dòng hoặc nhấn nút <i class="fa fa-check"></i> để chọn.
        <br />
        <strong>Lưu ý:</strong> Nhấn <kbd>Enter</kbd> trong ô lọc để áp dụng bộ lọc.
      </small>
    </div>
  </bs-modal-body>
</bs-modal>
